var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},_vm._l((_vm.events),function(e){return _c('div',{key:e.id,staticClass:"col-lg-4"},[_c('event',{attrs:{"event":e},on:{"clicked":function($event){return _vm.setCurrentEvent(e)}}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }